"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckrScreeningType = void 0;
exports.instanceOfCheckrScreeningType = instanceOfCheckrScreeningType;
exports.CheckrScreeningTypeFromJSON = CheckrScreeningTypeFromJSON;
exports.CheckrScreeningTypeFromJSONTyped = CheckrScreeningTypeFromJSONTyped;
exports.CheckrScreeningTypeToJSON = CheckrScreeningTypeToJSON;
exports.CheckrScreeningTypeToJSONTyped = CheckrScreeningTypeToJSONTyped;
/**
 *
 * @export
 */
exports.CheckrScreeningType = {
    SsnTrace: 'ssn_trace',
    SexOffenderSearch: 'sex_offender_search',
    GlobalWatchlistSearch: 'global_watchlist_search',
    NationalCriminalSearch: 'national_criminal_search',
    MunicipalCriminalSearch: 'municipal_criminal_search',
    CountyCriminalSearch: 'county_criminal_search',
    StateCriminalSearch: 'state_criminal_search',
    FederalCriminalSearch: 'federal_criminal_search',
    CountyCivilSearch: 'county_civil_search',
    FederalCivilSearch: 'federal_civil_search',
    PersonalReferenceVerification: 'personal_reference_verification',
    ProfessionalLicenseVerification: 'professional_license_verification',
    ProfessionalReferenceVerification: 'professional_reference_verification',
    EducationVerification: 'education_verification',
    EmploymentVerification: 'employment_verification',
    DrugScreening: 'drug_screening',
    InternationalCriminalSearch: 'international_criminal_search',
    MotorVehicleReport: 'motor_vehicle_report',
    EvictionSearch: 'eviction_search',
    CreditReport: 'credit_report',
    FacisSearch: 'facis_search'
};
function instanceOfCheckrScreeningType(value) {
    for (const key in exports.CheckrScreeningType) {
        if (Object.prototype.hasOwnProperty.call(exports.CheckrScreeningType, key)) {
            if (exports.CheckrScreeningType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function CheckrScreeningTypeFromJSON(json) {
    return CheckrScreeningTypeFromJSONTyped(json, false);
}
function CheckrScreeningTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CheckrScreeningTypeToJSON(value) {
    return value;
}
function CheckrScreeningTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=CheckrScreeningType.js.map